import { apiClient } from "helpers/api_helper";

export const getAllSNMCCGoldInwardData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/ProductDetails/GetSNMCCAndNonSNMCCProductHeaders`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};